import { render, staticRenderFns } from "./SnSerialList.vue?vue&type=template&id=7366af56&scoped=true&"
import script from "./SnSerialList.vue?vue&type=script&lang=js&"
export * from "./SnSerialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7366af56",
  null
  
)

export default component.exports